import React from 'react';

import Color from 'color';
import { AlineTooltip } from 'src/components';

import { FilledLockKeyholeIcon } from '../icons/FilledLockKeyholeIcon';

const BADGE_COLOR = Color.rgb(171, 171, 171);

export function PrivateCommentBadge(): JSX.Element {
  return (
    <AlineTooltip arrow placement="top" title="Private comment">
      <div>
        <FilledLockKeyholeIcon aria-label="Private comment" fill={BADGE_COLOR.toString()} />
      </div>
    </AlineTooltip>
  );
}
